import { createFileRoute, Outlet, useMatches, useNavigate } from '@tanstack/react-router'
import { AppShell } from '../../../../components/AppShell'
import { useDesa, useLogout, useSession } from '../../../../hooks/useApi'

export const Route = createFileRoute('/platform/desa/$desaId')({
  component: DesaDashboardLayout,
})

function DesaDashboardLayout() {
  const { desaId } = Route.useParams()
  const navigate = useNavigate()
  const { data: session } = useSession()
  const logout = useLogout()
  const { data: desa } = useDesa(desaId)
  const user = session?.user

  const matches = useMatches()
  const lastMatch = matches[matches.length - 1]
  const pathAfterDesaId = lastMatch?.pathname?.split(`/platform/desa/${desaId}`)[1]?.replace(/^\//, '') || ''
  const activeTab = pathAfterDesaId || 'ringkasan'

  const handleTabChange = (tab: string) => {
    const path = tab === 'ringkasan' ? `/platform/desa/${desaId}` : `/platform/desa/${desaId}/${tab}`
    navigate({ to: path as any })
  }

  return (
    <AppShell
      mode="desa"
      desaId={desaId}
      desaName={desa?.nama ?? desaId}
      desaLocation={[desa?.kecamatan, desa?.kabupaten].filter(Boolean).join(', ') || undefined}
      activeTab={activeTab}
      onTabChange={handleTabChange}
      userName={user?.name ?? 'Admin'}
      userEmail={user?.email ?? ''}
      onLogout={() => logout.mutate()}
      userRole={user?.role}
      userIsQc={(user as any)?.is_qc}
      userPermissions={(() => {
        try {
          const p = user?.permissions
          if (Array.isArray(p)) return p
          if (typeof p === 'string') return JSON.parse(p)
          return []
        } catch {
          return []
        }
      })()}
    >
      <Outlet />
    </AppShell>
  )
}
